/* eslint-disable react/no-array-index-key */
import React from 'react';
import zxcvbn from 'zxcvbn';
import { StrengthContainer, StrengthBar } from './styles';

const defaultColor = '#E0E0E0';

const colors = {
  0: ['#ED6B75', defaultColor, defaultColor], // Very Weak
  1: ['#ED6B75', '#ED6B75', defaultColor], // Weak
  2: ['#ED6B75', '#ED6B75', defaultColor], // Medium
  3: ['#ED6B75', '#FBBC05', defaultColor], // Moderate
  4: ['#62BB46', '#62BB46', '#62BB46'], // Strong
};

const PasswordStrengthIndicator = ({ password }: { password: string }) => {
  const statistics = zxcvbn(password);

  const barColors = colors[statistics.score] || [
    defaultColor,
    defaultColor,
    defaultColor,
  ];

  return (
    <StrengthContainer>
      {/* @ts-ignore has to extend interface of libs */}
      {statistics.password ? (
        <>
          {barColors.map((color, index) => (
            <StrengthBar key={`${color}-${index}`} color={color} />
          ))}
        </>
      ) : (
        <>
          {[defaultColor, defaultColor, defaultColor].map((color, index) => (
            <StrengthBar key={`${color}-${index}`} color={color} />
          ))}
        </>
      )}
    </StrengthContainer>
  );
};

export default PasswordStrengthIndicator;
